import React, { useState, useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import createLabelWithIcon from '#component/icon/label-icons';
import { isDataExist } from '#component/dashboard/helper';
import NotFoundMessage from '#component/general/not-found-message';
import { locationsSelector } from '#selector/shipment/overview';
import { CardDialog } from './card-dialog';
import { MapDialog } from './map-dialog';
import { DevicesDialog } from './devices-dialog';
import { ShipmentCard } from './shipment-card';
import { CardWrapper, CardsHint, BtnCnt, AddBtn, AddButtonLabel } from './styles';

export const MobileView = props => {
  const {
    data,
    loading,
    identifiersMap,
    replaceHistoryParams
  } = props;

  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [openMap, setOpenMap] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { defaultDevices, states, requestStatus } = useSelector(s => s.shipment, shallowEqual);
  const shipmentLoading = requestStatus !== 'succeeded' || requestStatus === 'idle';
  const locations = locationsSelector(defaultDevices);

  const [clickedDevices, setClickedDevices] = useState([]);

  const handleClickOpen = tabNum => {
    setOpen(!open);
    replaceHistoryParams({
      tabNum
    });
  };

  const handleOpenMapDialog = useCallback(() => {
    setOpenMap(!openMap);
  }, [openMap]);

  const handleClose = () => {
    setOpen(!open);
  };

  const handleCloseMap = () => {
    setOpenMap(!openMap);
  };

  return (
    <CardWrapper>
      {
      (!isDataExist(data) && !loading) ? (
        <NotFoundMessage>
          There are no shipments within 6 months
        </NotFoundMessage>
      ) : (
        <>
          <CardsHint variant="h6">
            Active shipments within 7 days
          </CardsHint>
          {Object.entries(identifiersMap).map(el => {
            const [index, identifier] = el;
            const itemsCount = data[index]?.length;
            const label = createLabelWithIcon(
              identifier.replace(' ', '_').toUpperCase(),
              false,
              false,
              false
            );
            return (
              <ShipmentCard
                key={index}
                index={index}
                label={label}
                identifier={identifier}
                itemsCount={itemsCount}
                handleOpen={handleClickOpen}
              />
            );
          })}
          <CardDialog
            open={open}
            isMobile={isMobile}
            isMapDialogOpened={openMap}
            handleClose={handleClose}
            handleOpenMapDialog={handleOpenMapDialog}
            {...props}
          />
          <MapDialog
            open={openMap}
            isMapDialogOpened={openMap}
            mapDataLoading={shipmentLoading}
            handleClose={handleCloseMap}
            locations={locations}
            destinations={states}
            defaultDevices={defaultDevices}
            clickDevices={setClickedDevices}
            {...props}
          />
          <DevicesDialog
            open={Boolean(clickedDevices.length)}
            handleClose={devices => {
              // "Escape"
              const d = Array.isArray(devices) ? devices : [];
              setClickedDevices(d);
            }}
            clickedDevices={clickedDevices}
          />
        </>)
      }
      <BtnCnt>
        <AddBtn
          size="small"
          color="secondary"
          aria-label="Add"
          component={Link}
          to="/addshipment"
        >
          <AddIcon />
          <AddButtonLabel>Create shipment</AddButtonLabel>
        </AddBtn>
      </BtnCnt>
    </CardWrapper>
  );
};
